'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRouter = require('react-router');

var _modules = require('redux/modules/modules');

var _resources = require('redux/modules/resources');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES_REGULAR = 'Yes, regularly';
var YES_SOMETIMES = 'Yes, sometimes';
var YES_JUST = 'Yes, just tried the one in this program';
var NO = 'No';
var YES = 'Yes';

var Module2App6 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module2,
    app: state.moduleData.data.module2.app6
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem, changeResource: _resources.changeResource })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2App6, _Component);

  function Module2App6() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2App6);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2App6.__proto__ || (0, _getPrototypeOf2.default)(Module2App6)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 2,
      appId: 6,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'Meal planning',
      buySameEachWeek: _this.props.app.buySameEachWeek || '',
      planMealRestWeek: _this.props.app.planMealRestWeek || '', // do you ever plan the meals that you'll prepare for the rest of the week
      howDidItGo: _this.props.app.howDidItGo || '',
      whyNot: _this.props.app.whyNot || '',
      seenMealPlanner: _this.props.app.seenMealPlanner || '',
      useMealPlanner: _this.props.app.useMealPlanner || '',
      tryUseMealPlanner: _this.props.app.tryUseMealPlanner || ''
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handlePlanMeal = function (event) {
      var obj = _this.state;
      obj.planMealRestWeek = event.target.value;
      obj.howDidItGo = '';
      obj.useMealPlanner = '';
      obj.tryUseMealPlanner = '';
      obj.seenMealPlanner = '';
      _this.setState(obj);
    }, _this.handleHowDidItGo = function (event) {
      var obj = _this.state;
      obj.howDidItGo = event.target.value;
      obj.useMealPlanner = '';
      obj.tryUseMealPlanner = '';
      _this.setState(obj);
    }, _this.handleUseMealPlanner = function (event) {
      var obj = _this.state;
      obj.useMealPlanner = event.target.value;
      obj.tryUseMealPlanner = '';
      _this.setState(obj);
    }, _this.handleTryUseMealPlanner = function (event) {
      var obj = _this.state;
      obj.tryUseMealPlanner = event.target.value;
      _this.setState(obj);
    }, _this.handleSeenMealPlanner = function (event) {
      var obj = _this.state;
      obj.seenMealPlanner = event.target.value;
      obj.useMealPlanner = '';
      obj.tryUseMealPlanner = '';
      _this.setState(obj);
    }, _this.handleOnClick = function (module, modtype, item, event) {
      event.preventDefault();
      _this.props.changeItem(module, modtype, item);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleResourceClick = function (module, item, event) {
      // console.log(event);
      _this.props.changeResource(module, item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /* *************** */
  /* HANDLE ON CLICK */
  /* *************** */

  // used to navigate to a resource item


  /*
   * General function used to change state of object
   */


  // used to navigate to a resource item


  (0, _createClass3.default)(Module2App6, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(_components.MealPlanning, null),
          _react2.default.createElement(
            'h5',
            null,
            'Before you go shopping do you ever plan the meals that you\'ll prepare for the rest of the week (or until you next shop)?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handlePlanMeal },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'planmeal', value: YES_REGULAR, checked: this.state.planMealRestWeek === YES_REGULAR },
              YES_REGULAR
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'planmeal', value: YES_SOMETIMES, checked: this.state.planMealRestWeek === YES_SOMETIMES },
              YES_SOMETIMES
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'planmeal', value: YES_JUST, checked: this.state.planMealRestWeek === YES_JUST },
              YES_JUST
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'planmeal', value: NO, checked: this.state.planMealRestWeek === NO },
              NO
            )
          ),
          (this.state.planMealRestWeek === YES_REGULAR || this.state.planMealRestWeek === YES_JUST) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s great!'
            )
          ),
          (this.state.planMealRestWeek === YES_REGULAR || this.state.planMealRestWeek === YES_SOMETIMES) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Do you already have a meal planner that you use? (A meal planner is a template/structured shopping list that includes all the foods they will need for meals/snacks that week)'
            )
          ),
          this.state.planMealRestWeek === YES_JUST && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'How did it go?'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleHowDidItGo },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'howdiditgo', value: 'Will use again', checked: this.state.howDidItGo === "Will use again" },
                  'Will use again'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'howdiditgo', value: 'Might use again', checked: this.state.howDidItGo === "Might use again" },
                  'Might use again'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'howdiditgo', value: 'Will use a different one', checked: this.state.howDidItGo === "Will use a different one" },
                  'Will use a different one'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'howdiditgo', value: 'Won\'t use again', checked: this.state.howDidItGo === "Won't use again" },
                  'Won\'t use again'
                )
              )
            ),
            this.state.howDidItGo === 'Won\'t use again' && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Why not?'
              ),
              _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'Why won\'t you use it again?', value: this.state.whyNot, onChange: this.handleChange.bind(this, 'whyNot') })
            )
          ),
          this.state.planMealRestWeek === NO && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Ok so you tend to buy the same thing each week?'
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text',
                placeholder: 'Do you buy the same thing each week?', onChange: this.handleChange.bind(this, 'buySameEachWeek'),
                value: this.state.buySameEachWeek }),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'That can work well for a lot of families - it can save time and hassle at the supermarket and preparing dinner each night. It\'s just important to make sure you have enough variety of foods including fruit and vegetables, to ensure that your child gets all the vitamins, minerals, fibre and protein he/she needs'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Meal planning can help you have fruits and vegetables in your home on a regular basis and this\'ll help your child and the whole family to eat healthy'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Planning can also save you time by helping you to buy everything you need in one go, so you won\'t have to duck out to the shops as often, and you\'re also less likely to grab take away because there\'s nothing to eat in the house'
                )
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Have you seen the meal-planner under Module 2 resources in this program?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleSeenMealPlanner },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'seenMealPlanner', value: 'Yes', checked: this.state.seenMealPlanner === "Yes" },
                'Yes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'seenMealPlanner', value: 'No', checked: this.state.seenMealPlanner === "No" },
                'No'
              )
            ),
            this.state.seenMealPlanner === YES && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                'You may have noticed that it makes you think about the meals that you are going to prepare as well as about the foods that you will need to make them.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'You should find that this makes your next shopping trip easier as you\'ll already know exactly what you\'ll need. It\'s helpful to put the filled-in plan up on the fridge (or somewhere convenient) as a quick reference to your meals for the week ahead.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'You will notice that in the example planner, there are fruit or vegetables provided at every meal.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Planning helps to increase opportunities for providing fruit and vegetables.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Would you like to try using the meal planner this week?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleUseMealPlanner },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'useMealPlanner', value: 'Yes', checked: this.state.useMealPlanner === "Yes" },
                  'Yes'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'useMealPlanner', value: 'No', checked: this.state.useMealPlanner === "No" },
                  'No'
                )
              )
            )
          ),
          this.state.useMealPlanner === YES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Could you please record this down in your strategies?'
            )
          ),
          this.state.useMealPlanner === NO && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s ok, we only provide you with suggestions that have worked for other families. You don\'t have to try every suggestion.'
            )
          ),
          this.state.seenMealPlanner === NO && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'It\'s under Module 2 Resources. Click here to look at it.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The first step is to think about, and write down, all the meals and snacks you are going to prepare that week.',
              _react2.default.createElement('br', null),
              'By planning your meals & snacks ahead of time you can plan to include fruit and vegetables at every meal and snack.',
              _react2.default.createElement('br', null),
              'The next step is to write a shopping list using all of the foods/item that you will need to make each meal and snack.',
              _react2.default.createElement('br', null),
              'We have split the shopping list into type of grocery items but you can write it down in any order.',
              _react2.default.createElement('br', null),
              'Would you like to try use the meal planner this week?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleTryUseMealPlanner },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'tryUseMealPlanner', value: 'Yes', checked: this.state.tryUseMealPlanner === "Yes" },
                'Yes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'tryUseMealPlanner', value: 'No', checked: this.state.tryUseMealPlanner === "No" },
                'No'
              )
            )
          ),
          this.state.tryUseMealPlanner === YES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Could you please record this down in your strategies?'
            )
          ),
          this.state.tryUseMealPlanner === NO && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s ok, we only provide you with suggestions that have worked for other families. You don\'t have to try every suggestion.'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h4',
              null,
              'What\'s next?'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Give the meal planning activity a go! You should find this ',
                  _react2.default.createElement(
                    'span',
                    { className: styles.orangeText },
                    'makes your next shopping trip easier'
                  ),
                  ' as you\'ll already know exactly what you\'ll need. It\'s helpful to put the filled-in plan up on the fridge (or somewhere convenient) as a quick reference to your meals for the week ahead.'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'You will notice in the example planner, there are',
                  _react2.default.createElement(
                    'span',
                    { className: styles.orangeText },
                    ' fruits or vegetables provided at every meal'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: styles.orangeText },
                    'Planning helps to increase opportunities for providing fruits or vegetables'
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/resourceslanding', onClick: this.handleResourceClick.bind(this, 2, 4) },
              'Click here for a sample meal plan and shopping list'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/module2', onClick: this.handleOnClick.bind(this, 2, 2, 2) },
              'Click here to fill in your own meal plan and shopping list'
            ),
            _react2.default.createElement('div', { className: styles.spacer20 }),
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module2App6;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  module: _propTypes2.default.number,
  modtype: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeItem: _propTypes2.default.func.isRequired,
  changeResource: _propTypes2.default.func.isRequired
}, _temp2)) || _class);

/* eslint-enable */

exports.default = Module2App6;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/App/App6.js
// module id = 1186
// module chunks = 0